//@flow
import env from '../../../environment';
import {postCreator, getCreator, deleteCreator} from '../../../http';

export const endpoints = Object.freeze({
  NOTES: `${env.baseApiUrl}/winehouse/admin/note`,
});

export const getNotesApi = getCreator(endpoints.NOTES);
export const saveNotesApi = postCreator(endpoints.NOTES);
export const deleteNotesApi = deleteCreator(endpoints.NOTES);
